import { useQuery } from "@tanstack/react-query";

import { queryKeyMap } from "@/features/query-client";

import { getLenderCompanyUsers } from "../api";

export const useGetLenderCompanyUsers = (lenderCompanyId: number) => {
  return useQuery({
    queryKey: queryKeyMap.getLenderCompanyUsers(lenderCompanyId),
    queryFn: async () => {
      return (await getLenderCompanyUsers(lenderCompanyId)).items;
    },
    enabled: !!lenderCompanyId,
  });
};
